import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {BroadcasterService} from "../broadcaster.service";
import {GridDataResult} from "@progress/kendo-angular-grid";
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class FormsListService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    }
    public getAbbyyForms(pageSize, pageIndex, sort, filters): Observable<GridDataResult> {
        return new Observable<GridDataResult>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/getABBYYForms',
                {sid: localStorage.getItem('token'), page_index: pageIndex, page_size: pageSize, sort, filters})
                .subscribe((res: GridDataResult) => {
                    res.data = res[0];
                    res.total = Number(res[1].total);
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
    public getAllOrganizations(): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/getOrgs',
                {sid: localStorage.getItem('token')})
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
    public getTestForms(): Observable<GridDataResult> {
        return new Observable<GridDataResult>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/getTestForms', {sid: localStorage.getItem('token')})
                .subscribe((res: any) => {
                    res.data = res[0];
                    res.total = Number(res[1].total);
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
  async markUploadError(forms): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/markAsUploadError', {sid: localStorage.getItem('token'), abbyy_forms: forms}));
      return res;
    } catch(e) {
      throw e;
    }
  }
  async claimForm(formId): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/claimForm',
        {sid: localStorage.getItem('token'), formId}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public markUploadError(forms): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/markAsUploadError',
    //             {sid: localStorage.getItem('token'), abbyy_forms: forms})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
    public uploadToLaz(): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/uploadLazarusApi', {},
                {headers, responseType: 'blob' as 'json' })
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
}
